import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "error", "errorMessage", "helpText", "label", "small", "tooltip", "truncatePlaceholder", "innerRef"];
import React from 'react';
import PropTypes from 'prop-types';
import ToolTip from '../ToolTip/ToolTip';
import { IconInfo } from '../Icons';
import { lightSteel } from '../../styles/colors';
import { Input, InputContainer, LabelText, ErrorMessage, HelpText, LabelContainer } from './FormInputStyledComponents';

function FormInput(props) {
  var id = props.id,
      error = props.error,
      errorMessage = props.errorMessage,
      helpText = props.helpText,
      label = props.label,
      small = props.small,
      tooltip = props.tooltip,
      truncatePlaceholder = props.truncatePlaceholder,
      innerRef = props.innerRef,
      inputProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(InputContainer, null, (label || tooltip) && /*#__PURE__*/React.createElement(LabelContainer, null, label && /*#__PURE__*/React.createElement(LabelText, null, label), tooltip && /*#__PURE__*/React.createElement(ToolTip, {
    position: "top",
    tip: tooltip,
    type: "arrow"
  }, /*#__PURE__*/React.createElement(IconInfo, {
    size: "medium",
    color: lightSteel
  }))), /*#__PURE__*/React.createElement(Input, _extends({
    small: small,
    ref: innerRef,
    id: id,
    error: error || !!errorMessage,
    truncatePlaceholder: truncatePlaceholder
  }, inputProps)), errorMessage && /*#__PURE__*/React.createElement(ErrorMessage, null, errorMessage), !errorMessage && helpText && /*#__PURE__*/React.createElement(HelpText, null, helpText));
}

FormInput.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.node,
  helpText: PropTypes.node,
  id: PropTypes.string,
  innerRef: PropTypes.shape({
    current: PropTypes.shape({})
  }),
  label: PropTypes.string,
  small: PropTypes.bool,
  tooltip: PropTypes.node,
  truncatePlaceholder: PropTypes.bool,
  type: PropTypes.oneOf(['email', 'text', 'tel', 'search', 'password', 'number'])
};
FormInput.defaultProps = {
  error: false,
  errorMessage: null,
  helpText: null,
  id: null,
  innerRef: null,
  label: null,
  small: false,
  tooltip: null,
  truncatePlaceholder: false,
  type: 'text'
};
export { FormInput as UnwrappedFormInput }; // eslint-disable-next-line react/no-multi-comp

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(FormInput, _extends({
    innerRef: ref
  }, props));
});